import { LocalizationProvider, StaticDateTimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useSignal } from "@preact/signals-react";
import dayjs from "dayjs";
import { INGDateTimePickerProps } from "../../library/NGFieldExtensions";
import { publishUserAction } from "../../library/analytics";
import { setupHandlers, setupLocalState } from "../../library/dataService";
import { partitionMUIClasses } from "../../library/utils";

export default function NGDateTimePicker({ config, context }: INGDateTimePickerProps) {
  const local = setupLocalState(
    config,
    {
      Disabled: useSignal(config.Disabled ?? false),
      Style: useSignal(config.Style ?? {}),
      Classes: useSignal(config.Classes ?? []),
      Value: useSignal(config.Value ?? dayjs(new Date())),
      MaxDate: useSignal(config.MaxDate ?? null),
      MinDate: useSignal(config.MinDate ?? null)
    },
    context
  );

  const handlers = setupHandlers(config, context);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <StaticDateTimePicker
        value={local.Value.value}
        onChange={(e) => {
          local.Value.value = e.value;
          const [_, classes] = partitionMUIClasses(local.Classes.value);
          publishUserAction(config, context, "datetime_picker_change", null, {
            Value: local.Value.value,
            EventCategory: "engagement",
            ElementClass: classes.join(" "),
          });
        }}
        maxDate={local.MaxDate?.value && dayjs(local.MaxDate.value)}
        minDate={local.MinDate?.value && dayjs(local.MinDate.value)}
        {...handlers}
      />
    </LocalizationProvider>
  );
}
